import { createSelector } from 'reselect'

export const getCitiesByCountry = createSelector(
  (state, country) => state.geoObjects && state.geoObjects.cities && state.geoObjects.cities.byCountry &&
    state.geoObjects.cities.byCountry[country] ? state.geoObjects.cities.byCountry[country] : [],
  (cities) => cities
)
